import moment from 'moment';
import { convertTimestampMilliseconds } from '../util/Util';
import {
  DATE_FORMAT,
  DATE_FORMAT_DD_MM,
  DATE_FORMAT_MM_YYYY,
  DATETIME_FORMAT,
  DATETIME_FORMAT_DD_MM,
  DATETIME_FORMAT_DD_MM_HH_MM,
  TIME_FORMAT,
  TIME_FORMAT_HH_MM,
} from '../constants';

export const DATE_FORMAT_YYYY_MM_DD_GOOGLE_CHARTS = 'dd.MM.YYYY';
export const DATE_FORMAT_MM_DD_GOOGLE_CHARTS = 'dd.MM';
export const DATE_FORMAT_YYYY_MM_GOOGLE_CHARTS = 'MM.YYYY';
export const DATETIME_FORMAT_MM_DD_GOOGLE_CHARTS = 'dd.MM HH:mm:ss';
export const DATETIME_FORMAT_MM_DD_HH_MM_GOOGLE_CHARTS = 'dd.MM HH:mm';
export const DATETIME_FORMAT_GOOGLE_CHARTS = 'dd.MM.YYYY HH:mm:ss';
export const TIME_FORMAT_GOOGLE_CHARTS = 'HH:mm:ss';
export const TIME_FORMAT_HH_MM_GOOGLE_CHARTS = 'HH:mm';

const mapping = {
  [DATE_FORMAT]: DATE_FORMAT_YYYY_MM_DD_GOOGLE_CHARTS,
  [DATE_FORMAT_DD_MM]: DATE_FORMAT_MM_DD_GOOGLE_CHARTS,
  [DATE_FORMAT_MM_YYYY]: DATE_FORMAT_YYYY_MM_GOOGLE_CHARTS,
  [DATETIME_FORMAT]: DATETIME_FORMAT_GOOGLE_CHARTS,
  [DATETIME_FORMAT_DD_MM]: DATETIME_FORMAT_MM_DD_GOOGLE_CHARTS,
  [DATETIME_FORMAT_DD_MM_HH_MM]: DATETIME_FORMAT_MM_DD_HH_MM_GOOGLE_CHARTS,
  [TIME_FORMAT]: TIME_FORMAT_GOOGLE_CHARTS,
  [TIME_FORMAT_HH_MM]: TIME_FORMAT_HH_MM_GOOGLE_CHARTS,
};

/**
 * Get data format google charts
 * @param string dateFormat
 * @return string dateFormatGoogle
 */
export const getDateFormatGoogleCharts = (dateFormat) => {
  if (!mapping[dateFormat]) {
    return mapping[DATETIME_FORMAT];
  }
  return mapping[dateFormat];
};

/**
 * Get date format
 * @param timestamp start
 * @param timestamp end
 * @return string date format
 */
export const getDateFormat = (start, end) => {
  const minTS = moment(convertTimestampMilliseconds(start));
  const maxTS = moment(convertTimestampMilliseconds(end));
  const diff = maxTS.diff(minTS);
  const duration = moment.duration(diff);

  if (duration.get('years') > 0) {
    return DATE_FORMAT_MM_YYYY;
  }

  if (duration.get('months') > 0) {
    return DATE_FORMAT;
  }

  if (duration.get('days') > 0) {
    if (duration.get('days') < 10) {
      return DATETIME_FORMAT_DD_MM_HH_MM;
    }
    return DATE_FORMAT_DD_MM;
  }

  if (duration.get('hours') > 1) {
    return TIME_FORMAT_HH_MM;
  }

  return TIME_FORMAT;
};

// used to change the range of the size
const MAX_POINT_SIZE = 6;
const MIN_POINT_SIZE = 2;
// coefficient to regulate the density depends of the width
const DELTA_WIDTH = 900;
// coefficient to regulate the density depends of number of points
const DELTA_DATA = 130;
/**
 * It return size of de points depending of the width or number of the points,
 * enough to see points connected between lines.
 *
 * The deltas are choose to see 100 points in a chart whit width = 1800,
 * the size would be decrees lineally like a plane actuation
 *
 * @param {number} sizeOfData length of data showed
 * @param {*} widthChart width of the chart
 * @returns PointSize from <MIN_POINT_SIZE> to <MAX_POINT_SIZE> or undefined
 */
export function getPointSize(sizeOfData, widthChart) {
  const minWidthChart = Math.min(DELTA_WIDTH, widthChart);
  const minSize = Math.min(DELTA_DATA, sizeOfData);
  const density =
    MAX_POINT_SIZE *
    // Use pow to decrees the size in no lineal form
    Math.pow(minWidthChart / DELTA_WIDTH - minSize / DELTA_DATA, 1 / 1.5);
  return density > MIN_POINT_SIZE ? density : undefined;
}
